import moment from 'moment-timezone';

import { LanguageService, UserUmanforge } from '@umanforge/common';
import { ModifyUser } from 'interfaces/api_user.interfaces';

import { MAX_LENGTH_ENTITY } from '../../constants/limite.constants';

import { Input } from '../../components/inputs/input.component';
import { Select } from '../../components/inputs/select.component';
import { LanguageSelector } from '../../components/menu/language_selector.component';

import { FirstnameIcon } from '../../components/icons/firstname_icon.component';
import { LastnameIcon } from '../../components/icons/lastname_icon.component';
import { EmailIcon } from '../../components/icons/email_icon.component';
import { LanguageIcon } from '../../components/icons/language_icon.component';
import { TimezoneIcon } from '../../components/icons/timezone_icon.component';
import { useEffect, useState } from 'react';
import { GlobalService } from 'services/global.service';
import SendFileInput from '../../@common_components/inputs/sendFileInput.component';


interface ModifyUserFiledsProps {
  user: UserUmanforge;
  onUserChange: ( user: ModifyUser ) => void;
  t: ( key: string ) => string;
  canEditAvatar: boolean;
  avatarInitialUrl: string | null;
  onAvatarFileChange: ( file: File | null ) => void;
  onAvatarInitialUrlChange: ( url: string | null ) => void;
  onAvatarChanged: ( changed: boolean ) => void;
}

export function ModifyUserFileds( props: ModifyUserFiledsProps ) {
  const { user, onUserChange, t, canEditAvatar, avatarInitialUrl, onAvatarFileChange, onAvatarInitialUrlChange, onAvatarChanged } = props;
  const [ modifyUser, setModifyUser ] = useState<ModifyUser>( {} );
  const [ isFirstRender, setIsFirstRender ] = useState( true );

  useEffect( () => {
    setIsFirstRender( false );
  }, [] );

  useEffect( () => {
    if ( !isFirstRender ) {
      onUserChange( modifyUser );
    }
  }, [ modifyUser ] );

  return (
    <div className='flex flex-col max-w-[550px] xl:max-w-[800px] w-full h-full gap-4'>
      <div className='flex gap-4'>
        <Input
          required
          maxLength={ MAX_LENGTH_ENTITY.UF_USER_FIRSTNAME }
          disabled={ !user.isAdminOfUser }
          label={ t( 'firstname' ) }
          value={ user.firstname ?? '' }
          onChange={ newFirstname => {
            modifyUser.firstname = user?.firstname != newFirstname ? newFirstname : undefined;
            setModifyUser( structuredClone( modifyUser ) );
          } }
          placeholder='Jean'
          icon={ <FirstnameIcon className='w-8 h-8'/> }
        />
        <Input
          required
          maxLength={ MAX_LENGTH_ENTITY.UF_USER_LASTNAME }
          disabled={ !user.isAdminOfUser }
          label={ t( 'Lastname' ) }
          value={ user.lastname ?? '' }
          onChange={ newLastname => {
            modifyUser.lastname = user?.lastname != newLastname ? newLastname : undefined;
            setModifyUser( structuredClone( modifyUser ) );
          } }
          placeholder='Dupont'
          icon={ <LastnameIcon className='w-8 h-8'/> }
        />
      </div>
      <div className='flex flex-col gap-4 '>
        <Input
          required
          maxLength={ MAX_LENGTH_ENTITY.UF_USER_EMAIL }
          disabled={ !user.isAdminOfUser }
          label={ t( 'Email' ) }
          value={ user.email ?? '' }
          checkContent={ email => { return GlobalService.validateEmail( email ) ? null : t( 'please_enter_a_valid_email_address' ); } }
          onChange={ newEmail => {
            modifyUser.email = user?.email != newEmail ? newEmail : undefined;
            setModifyUser( structuredClone( modifyUser ) );
          } }
          placeholder='jean.dupont@exemple.com'
          icon={ <EmailIcon className='w-8 h-8'/> }
        />
        <div className='w-full'>
          <span>{ t( 'Language' ) }</span>
          <LanguageSelector
            disabled={ !user.isAdminOfUser }
            value={ LanguageService.getLanguages().find( lang => { return lang.value == user.language; } ) }
            onChange={ newLang => {
              modifyUser.language = user?.language != newLang.value ? newLang.value : undefined;
              setModifyUser( structuredClone( modifyUser ) );
            } }
            menuPlacement='bottom'
            icon={ <LanguageIcon className='w-8 h-8'/> }
          />
        </div>
        <Select
          required
          disabled={ !user.isAdminOfUser }
          label={t( 'Time zone' )}
          value={ { value: user.timezone, label: user.timezone } }
          options={ moment.tz.names().map( tz => { return { value: tz, label: tz }; } ) }
          onChange={ newTimeZone => {
            modifyUser.timezone = user?.timezone != newTimeZone.value ? newTimeZone.value : undefined;
            setModifyUser( structuredClone( modifyUser ) );
          } }
          icon={ <TimezoneIcon className='w-8 h-8'/> }
        />
        <div className='mt-2'>
          <SendFileInput
            label={ t( 'avatar' ) }
            multipleFiles={ false }
            soloFile
            disable={ !canEditAvatar }
            acceptedFormats={ [ 'image/png', 'image/jpeg' ] }
            onFilesChange={ files => {
              const file = files && files.length > 0 ? files[ 0 ] : null;
              onAvatarFileChange( file?.file ?? null );
              onAvatarChanged( !!file );
            } }
            initialUrl={ avatarInitialUrl }
            onInitialRemove={ () => {
              onAvatarInitialUrlChange( null );
              onAvatarChanged( true );
            } }
          />
        </div>
      </div>
    </div>
  );
}